
<div *ngIf="image && !is360" (click)="onDivClick()" class="image-item">

  <div class="image-target">
    <fa-icon icon="crosshairs" [ngStyle]="{ color:image['markedInPhotogram'] ? 'blue' : 'red', top: top, left: left }" *ngIf="!this.mapComp.imageComp.rightClicked && image && image.selected_position && image.selected_position.x > 0 && image.image.image_height > 0"></fa-icon>
    <ng-container *ngIf="is360">
      <fa-icon class="fdm-linked fdm-floating-icon" icon="globe"></fa-icon>
    </ng-container>
    <img vlink="image.png" [model]="image" />
  </div>

  <!-- Fly camera to -->
    
  <div class="image-label" [title]="'lng='+image.llng + ',lat='+image.llat">
    <fa-icon *ngIf="image.llng && image.llat" (click)="flyToImage(image);$event.stopPropagation();" class="fdm-linked fdm-floating-icon" icon="paper-plane" [matTooltip]="'MAP.FLY_TO' | translate"></fa-icon>
    <!-- <fa-icon class="fdm-linked fdm-floating-icon" (click)="redetect(image)" icon="cog"></fa-icon> -->
    <span [title]="imageName">{{ imageName }}</span>
  </div>
  
</div>

<div *ngIf="image && is360" class="image-item">

  <div class="image-target">
    <fa-icon icon="crosshairs" [ngStyle]="{ color:image['markedInPhotogram'] ? 'blue' : 'red', top: top, left: left }" *ngIf="!this.mapComp.imageComp.rightClicked && image && image.selected_position && image.selected_position.x > 0 && image.image.image_height > 0"></fa-icon>
    <fa-icon class="fdm-icon-image-info" icon="globe"></fa-icon>
    <img vlink="image.png" [model]="image" />
  </div>

  <!-- Fly camera to -->
    
  <div class="image-label" [title]="'lng='+image.llng + ',lat='+image.llat">
    <fa-icon *ngIf="image.llng && image.llat" (click)="flyToImage(image);$event.stopPropagation();" class="fdm-linked fdm-floating-icon" icon="paper-plane" [matTooltip]="'MAP.FLY_TO' | translate"></fa-icon>
    <span [title]="imageName">{{ imageName }}</span>
  </div>
  
</div>

